module.exports = __webpack_public_path__ + "img/HoneyNet_White.6620fac3.svg";